module.exports = __webpack_public_path__ + "img/icon_code_2.b874be56.webp";